import React from "react";
import { Tooltip } from "primereact/tooltip";
import { ProgressSpinner } from "primereact/progressspinner";

type DynamicTooltipProps = {
  target: string;
  data: Array<{ [key: string]: string } | string> | undefined;
};

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const DynamicTooltip = ({ target, data }: DynamicTooltipProps) => (
  <Tooltip className="dynamic-tooltip" target={target}>
    {data ? (
      data.map(obj => {
        if (typeof obj === "object") {
          const tempKey = Object.keys(obj)[0];
          const value = Object.values(obj)[0];
          return (
            <div key={tempKey}>
              <b>{capitalize(tempKey)}</b>: <span>{value}</span>
            </div>
          );
        }
        return (
          <div key={obj}>
            <span>{obj}</span>
          </div>
        );
      })
    ) : (
      <ProgressSpinner style={{ width: "15px", height: "15px" }} strokeWidth="10" />
    )}
  </Tooltip>
);

export default DynamicTooltip;
